import OwnerList from '../../views/Owner/OwnerList';
import OwnerEdit from '../../views/Owner/OwnerEdit';
import SearchBar from '../../components/SearchBar';

export default [
    {
        path: '/proprietarios',
        name: 'owner.list',
        component: OwnerList,
        meta: {
            pageTitle: 'Proprietários',
            searchBar: SearchBar,
            breadcrumb: [
                { label: 'Proprietários' },
            ],
        },
    },
    {
        path: '/proprietarios/cadastro',
        name: 'owner.create',
        component: OwnerEdit,
        meta: {
            pageTitle: 'Cadastro de Proprietário',
            breadcrumb: [
                { label: 'Proprietários', routeName: 'owner.list' },
                { label: 'Cadastro de Proprietário' },
            ],
        },
    },
    {
        path: '/proprietarios/:id',
        name: 'owner.edit',
        component: OwnerEdit,
        meta: {
            pageTitle: 'Edição de Proprietário',
            breadcrumb: [
                { label: 'Proprietários', routeName: 'owner.list' },
                { label: 'Edição de Proprietário' },
            ],
        },
    },
];
